<script>
    import { onMount } from "svelte";
    import { pop } from "svelte-spa-router";
    import { cuenta, documentos } from "./../controlador/store.js";
    export let params;
    let print;
    let telefono = '';
    let receta = {};
    let href = `https://wa.me/?text=La receta Actual es : https://verreceta.onrender.com/#/${params.id}`;
    let hrefTel = `whatsapp://send?text=La receta Actual es : https://verreceta.onrender.com/#/${params.id}`;
    onMount(() => {
        receta = $documentos.filter((el) => el._id == params.id)[0];
        console.log(receta);
    });
    function imprimir(){
        
        pop();
    }
    function volver(){
        pop();
    }
</script>

<div class="container centro">
	<h2>Enviar Receta</h2>
	<div class="fila">
	  <input type="text" bind:value={telefono} placeholder="N° de Telefono Ej: +54(298)4247439">
	</div>
	<div class="fila">
	  <button on:click={imprimir} class="boton"><i class="ph-paper-plane-right"></i> Enviar</button>
	  <a href="" data-action="share/whatsapp/share"><i class="ph-x-circle"></i> Volver</a>
	</div>
  </div>

  <style>
	  h2{
		color: white;
		width: 100%;
		padding: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.centro{
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  justify-content: flex-start;
	}
	.fila{
	  width: 90%;
	  max-width: 380px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	}
	.cuerpo{
	  width: 90%;
	  max-width: 380px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	}
	input{
	  width: 90%;
	  max-width: 380px;
	  margin-bottom: 10px;
	  border: none;
	  outline: none;
	  border-radius: 10px;
	  height: 30px;
	  padding: 5px;
	}
	.boton{
	  margin: 10px;
	  background: transparent;
	  padding: 5px;
	  color: white;
	  font-size: 20px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  border: none;
	  outline: none;
	  cursor: pointer;
	}
	i{
	  margin-top: 5px;
	  font-size: 30px;
	}
  </style>